import React from "react";
import { useHistory } from "react-router-dom";
import { Area } from "../../../types";
import type { AiContext } from "./context";

type AiLauncherValue = {
  pending: AiContext | null;
  launch: (context: AiContext) => void;
  clear: () => void;
};

const AiLauncherCtx = React.createContext<AiLauncherValue | null>(null);

export const AiLauncherProvider = ({ children }: { children: React.ReactNode }) => {
  const history = useHistory();
  const [pending, setPending] = React.useState<AiContext | null>(null);
  const launch = React.useCallback(
    (context: AiContext) => {
      setPending(context);
      history.push(Area.HealthForms_Assistant);
    },
    [history]
  );
  const clear = React.useCallback(() => setPending(null), []);
  return <AiLauncherCtx.Provider value={{ pending, launch, clear }}>{children}</AiLauncherCtx.Provider>;
};

export const useAiLauncher = (): AiLauncherValue => {
  const value = React.useContext(AiLauncherCtx);
  if (!value) throw new Error("useAiLauncher must be used within AiLauncherProvider");
  return value;
};
